import { APP_CONTEXT } from '../actionTypes';
import { setItemToStore } from '../../utils/utils';

const initialState = {
  isAuthenticated: false,
  plans: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case APP_CONTEXT.SET_APP_PROPS:
      return { ...state, ...payload };

    case APP_CONTEXT.LOGIN_SUCCESS:
    case APP_CONTEXT.GOOGLE_LOGIN_SUCCESS:
      setItemToStore('user', { token: payload.token });
      return { ...state, isAuthenticated: true };

    case APP_CONTEXT.SIGNUP_SUCCESS: {
      setItemToStore('user', { token: payload.token });
      const { email, token } = payload;

      return {
        ...state,
        email,
        token,
        isAuthenticated: true,
        isRegistered: true,
      };
    }
    case APP_CONTEXT.CONFIRM_EMAIL_SUCCESS:
      return { ...state, isEmailConfirmed: true };

    case APP_CONTEXT.FORGOT_PASSWORD_SUCCESS:
      return { ...state, isForgotPasswordSent: true };

    case APP_CONTEXT.RESET_PASSWORD_VERIFY_SUCCESS:
      return { ...state, hasResetPasswordVerified: true };

    case APP_CONTEXT.RESET_PASSWORD_SUCCESS:
      return { ...state, isPasswordReset: true };

    case APP_CONTEXT.LOGIN_FAILURE:
    case APP_CONTEXT.SIGNUP_FAILURE:
    case APP_CONTEXT.RESEND_EMAIL_SUCCESS:
      return state;

    case APP_CONTEXT.IS_AUTHENTICATED:
      return { ...state, isAuthenticated: payload };

    case APP_CONTEXT.RESET_APP_PROPS: {
      localStorage.removeItem('user');
      return initialState;
    }

    case APP_CONTEXT.AUTH_INVITATION_SUCCESS: {
      // if (payload.isInvitationAccepted && payload.businessUser)
      // updateStore(payload.businessUser);
      return {
        ...state,
        invitationToken: payload.token,
        isInvitationAccepted: payload.isInvitationAccepted,
      };
    }

    case APP_CONTEXT.AUTH_INVITATION_FAILURE: {
      return { ...state, invitationToken: null };
    }

    case APP_CONTEXT.ADD_INVITATION_SUCCESS: {
      return { ...state, invitationAccepted: payload };
    }

    case APP_CONTEXT.GET_WSREFERNCE_SUCCESS: {
      return { ...state, wsReference: payload.workspace };
    }

    case APP_CONTEXT.GET_WSREFERNCE_FAILURE: {
      return { ...state, wsReference: undefined };
    }

    default:
      return state;
  }
};
